module.exports = __webpack_public_path__ + "static/media/chatime.ad210130.JPG";